import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { LocationSelectorInfo } from 'src/app/admin/user/shared/models/locationSelectorModel';
import { getLobbyLocationSelected, getShouldSignInLocationDisabled } from 'src/app/state';
import * as CoreActions from 'src/app/state/actions/core.actions';
import { State } from 'src/app/state/app.state';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-sign-in-modal-popup',
  templateUrl: './sign-in-modal-popup.component.html',
  styleUrls: ['./sign-in-modal-popup.component.scss']
})
export class SignInModalPopupComponent implements OnInit, OnDestroy {

  constructor(private store: Store<State>, private session: SessionService) { }

  [key: string]: any;

  public windowOpened = false;
  public locationId: number = 0;
  public locationName: string = '';
  public selectorDisabled: boolean = false;

  locationData?: LocationSelectorInfo;
  @ViewChild('popupModal') public modal?: ElementRef;
  @Input() public dialogOpened: boolean = false;
  @Output() public dialogOpenedChange: EventEmitter<boolean> = new EventEmitter(false);
  @Input() public message: string = '';
  @Input() public header: string = '';
  @Input() public actionYesLabel: string = '';
  @Input() public actionNoLabel: string = '';
  @Input() public isInfo = false;
  @Output() public submitted = new EventEmitter();
  @Output() public cancelled = new EventEmitter();

  signInSubscriptions = new Subscription();

  ngOnInit() {
    this.setDefaultBranch();
  }

  ngOnDestroy(): void {
    this.signInSubscriptions.unsubscribe();
  }

  /**
 * Sets the default branch location from the Redux store.
 * Subscribes to `getLobbyLocationSelected` and `getShouldSignInLocationDisabled` to update local variables.
 * Updates `locationData` object with the selected location details.
 * Adds the subscription to `signInSubscriptions`.
 */
  private setDefaultBranch() {

    const locationSubscription = this.store.select(getLobbyLocationSelected)
      .subscribe(loc => {
        this.locationId = loc.locationId as number;
        this.locationName = loc.locationName;
        this.store.select(getShouldSignInLocationDisabled)
          .subscribe(selectorChange => {
            this.selectorDisabled = selectorChange || loc.dropDownDisabled;
          });

        this.locationData = {
          id: loc.locationId,
          locationName: loc.locationName,
          utcoffsetInMinutes: loc.utcOffSet,
          locationCode: loc.locationCode,
          locationTypeId: 0,
          timezoneId: loc.timezoneId,
          timeZoneName: loc.timeZoneName,
          dropDownDisabled: loc.dropDownDisabled,
          lastLocationAutoWraupTime: loc.lastLocationAutoWraupTime || ''
        };
      });

    this.signInSubscriptions.add(locationSubscription);
  }

  public locationChange(locationData: LocationSelectorInfo) {
    
    this.locationData = locationData;
    
    if (typeof locationData.id == 'number') {
      this.locationId = locationData.id;
    } else {
      this.locationId = 0;
    }
    
    this.locationName = locationData.locationName;
  }

  public close(component: string) {
    this.cancelled.emit();
    this[`${component}Opened`] = false;
    this.dialogOpened = false;
  }

  public open(component: string) {
    this[`${component}Opened`] = true;
    this.dialogOpened = true;
  }

  public action(status: 'yes' | 'no') {
    this.dialogOpened = false;
  }

  public emitSubmit(state: string): void {
    if (!this.locationData) {
      return;
    }

    this.dialogOpened = false;

    this.store.dispatch(CoreActions.updateLobbyLocationSelectorInfo({
      payload: {
        lobbyLocationSelectorInfo: this.locationData
      }
    }));
    this.session.setLobbyLocation(this.locationData);
    this.submitted.emit();

  }

  public emitCancel(state: string): void {
    this.cancelled.emit();
    this.dialogOpened = false;
  }

}
